import { render, staticRenderFns } from "./ExpensesAdd.vue?vue&type=template&id=c51690f8&scoped=true&"
import script from "./ExpensesAdd.vue?vue&type=script&lang=js&"
export * from "./ExpensesAdd.vue?vue&type=script&lang=js&"
import style0 from "./ExpensesAdd.vue?vue&type=style&index=0&id=c51690f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c51690f8",
  null
  
)

export default component.exports